import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent {
  @Output() closeModalEvent = new EventEmitter();
  @Input() title!: string;
  @Input() subTitle!: string;

  private destroy$: Subject<void> = new Subject<void>();
  
  closeModal() {
    this.closeModalEvent.emit()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
